import styled from '@emotion/styled';

const LogoLink = styled.a`
  fill: ${({ theme }) => theme.colors.brand.green100};

  &:focus-visible {
    border-radius: ${({ theme }) => theme.radius.xs};
    outline: 0.125rem dashed ${({ theme }) => theme.colors.brand.orange100};
    outline-offset: 0.25rem;
  }
`;

export { LogoLink };
